import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2305a81d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100 h-100 d-flex flex-column" }
const _hoisted_2 = { class: "d-flex align-items-end gap-3" }
const _hoisted_3 = { style: {"flex":"0 0 33.33%"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"0 0 33.33%"} }, null, -1))
const _hoisted_5 = { style: {"flex":"0 0 33.33%"} }
const _hoisted_6 = {
  class: "d-block mb-2 text-center",
  style: {"font-size":"0.9rem"}
}
const _hoisted_7 = {
  ref: "mapParentContainer",
  class: "flex-grow-1 position-relative"
}
const _hoisted_8 = {
  ref: "mapcontainer",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_9 = ["title"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-window-maximize" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  ref: "fullscreenMapParent",
  style: {"width":"100%","height":"100%","position":"relative"}
}
const _hoisted_13 = ["title"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-window-minimize" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "lead mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_translate = _resolveComponent("translate")!
  const _component_Slider = _resolveComponent("Slider")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Accordion, {
      class: "w-100 mb-2",
      style: {"border":"none"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AccordionTab, {
          header: _ctx.i18n.$gettext('Kartenebenen')
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.layerMode,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.layerMode) = $event)),
                  options: _ctx.layerModeOptions,
                  "option-label": "label",
                  "option-value": "value",
                  class: "w-100"
                }, null, 8, ["modelValue", "options"])
              ]),
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("label", _hoisted_6, [
                  _createVNode(_component_translate, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Kataster Deckkraft")
                    ]),
                    _: 1
                  }),
                  _createTextVNode(": " + _toDisplayString(Math.round(_ctx.katasterOpacity * 100)) + "% ", 1)
                ]),
                _createVNode(_component_Slider, {
                  modelValue: _ctx.katasterOpacity,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.katasterOpacity) = $event)),
                  min: 0,
                  max: 1,
                  step: 0.1,
                  class: "w-100"
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["header"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, null, 512),
      _createElementVNode("button", {
        type: "button",
        class: "fullscreen-map-button",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openFullscreen && _ctx.openFullscreen(...args))),
        title: _ctx.i18n.$gettext('Vollbildansicht')
      }, _hoisted_11, 8, _hoisted_9)
    ], 512),
    _createVNode(_component_Dialog, {
      visible: _ctx.showFullscreenDialog,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showFullscreenDialog) = $event)),
      modal: true,
      closable: false,
      draggable: false,
      showHeader: false,
      style: {"width":"100vw","height":"100vh","margin":"0","max-height":"100vh"},
      "content-style": "padding: 0; height: 100vh;"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            type: "button",
            class: "fullscreen-close-button",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeFullscreen && _ctx.closeFullscreen(...args))),
            title: _ctx.i18n.$gettext('Schließen')
          }, _hoisted_15, 8, _hoisted_13)
        ], 512)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.showMarkerEditDialog,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showMarkerEditDialog) = $event)),
      modal: true,
      "close-on-escape": false,
      onHide: _ctx.closeEditMarkerDialog
    }, {
      header: _withCtx(() => [
        _createElementVNode("p", _hoisted_16, [
          _createVNode(_component_translate, null, {
            default: _withCtx(() => [
              _createTextVNode("Marker bearbeiten")
            ]),
            _: 1
          })
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: _ctx.i18n.$gettext('Abbrechen'),
          icon: "pi pi-times",
          class: "p-button-text",
          onClick: _ctx.closeEditMarkerDialog
        }, null, 8, ["label", "onClick"]),
        _createVNode(_component_Button, {
          label: _ctx.i18n.$gettext('Annehmen'),
          icon: "pi pi-check",
          autofocus: "",
          onClick: _ctx.applyChanges
        }, null, 8, ["label", "onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_translate, null, {
          default: _withCtx(() => [
            _createTextVNode("Panorama verknüpfen")
          ]),
          _: 1
        }),
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.selectedPanorama,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedPanorama) = $event)),
          options: _ctx.panoramaTargetOptions,
          class: "w-100 mt-3",
          "option-label": "label",
          "option-value": "value",
          "show-clear": "",
          label: _ctx.i18n.$gettext('Panorama')
        }, null, 8, ["modelValue", "options", "label"])
      ]),
      _: 1
    }, 8, ["visible", "onHide"])
  ]))
}